import PropTypes from 'prop-types'
import { Text } from '@artprov/design-system'
import { ERROR_FALLBACK_LABELS } from '../constants/labels'

/**
 * Componente de fallback para Sentry.ErrorBoundary.
 * Se muestra cuando ocurre un error no capturado en el árbol de componentes.
 *
 * @param {Object} props
 * @param {Error} props.error - Error capturado
 * @param {Function} props.resetError - Función para reintentar el renderizado
 */
const ErrorFallback = ({ error, resetError }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <div className="bg-white rounded-lg p-8 max-w-md text-center border border-red-200 shadow-sm">
        <div className="mb-4">
          <svg className="w-16 h-16 mx-auto text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
            />
          </svg>
        </div>
        <Text variant="h6" className="text-gray-800 font-semibold mb-2">
          {ERROR_FALLBACK_LABELS.TITLE}
        </Text>
        <Text variant="body2" className="text-gray-500 mb-6">
          {ERROR_FALLBACK_LABELS.DESCRIPTION}
        </Text>
        {import.meta.env.DEV && error?.message && (
          <pre className="text-left text-xs text-red-600 bg-red-50 rounded p-3 mb-4 overflow-auto max-h-32">
            {error.message}
          </pre>
        )}
        <button
          onClick={resetError}
          className="px-4 py-2 bg-primary-100 text-white rounded hover:bg-primary-80 transition-colors text-sm"
        >
          {ERROR_FALLBACK_LABELS.RETRY}
        </button>
      </div>
    </div>
  )
}

ErrorFallback.propTypes = {
  error: PropTypes.instanceOf(Error).isRequired,
  resetError: PropTypes.func.isRequired,
}

export default ErrorFallback
